export const UPDATE_TOKEN = 'auth/UPDATE_TOKEN'
export const UPDATE_TOKEN_SUCCESS = 'auth/UPDATE_TOKEN_SUCCESS'
export const UPDATE_TOKEN_ERROR = 'auth/UPDATE_TOKEN_ERROR'
